export default __webpack_public_path__ + "static/media/FamilyPortrait.15ab4422.jpg";